<template>
  <div class="setMealSeries table-hook fadeInRight">
    <div class="title-box">
      <span class="m-title">套餐系列管理</span>
      <el-form inline class="hook right themed-form search-form" style="line-height: 40px;" :model="searchForm">
        <el-form-item label="系列名称:">
          <el-input v-model="searchForm.name" placeholder="请输入系列名称"></el-input>
        </el-form-item>
        <el-form-item label="系列编码:">
          <el-input v-model="searchForm.code" placeholder="请输入系列编码"></el-input>
        </el-form-item>
        <el-form-item label="状态:">
          <el-select v-model="searchForm.status" placeholder="请选择状态">
            <el-option label="全部" value=""></el-option>
            <el-option label="启用" :value="1"></el-option>
            <el-option label="禁用" :value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="handleSearch" class="themed-button">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="table-content">
      <div class="table-menu-list">
        <div class="right">
          <el-button type="primary" @click="handleAdd" class="themed-button">
            <i class="fa fa-plus"></i> 新增系列
          </el-button>

        </div>
      </div>

      <el-table
        :data="tableData"
        style="width: 100%"
        v-loading="loading"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="name" label="系列名称" width="200">
          <template slot-scope="scope">
            <i class="fa fa-folder" style="color: #409EFF; margin-right: 5px;"></i>
            {{ scope.row.name }}
          </template>
        </el-table-column>
        <el-table-column prop="code" label="系列编码" width="150"></el-table-column>
        <el-table-column prop="description" label="描述" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column prop="mealCount" label="套餐数量" width="100">
          <template slot-scope="scope">
            <span style="color: #409EFF;">{{ scope.row.mealCount || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="80">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === 1" type="success" size="mini">启用</el-tag>
            <el-tag v-else type="danger" size="mini">禁用</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序" width="80"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" width="150"></el-table-column>
        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row)" 
                       :disabled="scope.row.mealCount > 0">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-wrap">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchForm.pageNo"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="searchForm.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <!-- 新增/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px" @close="handleDialogClose">
      <el-form :model="formData" ref="seriesForm" :rules="formRules" label-width="120px">
        <el-form-item label="系列名称" prop="name">
          <el-input v-model="formData.name" placeholder="请输入系列名称"></el-input>
        </el-form-item>
        <el-form-item label="系列编码" prop="code">
          <el-input v-model="formData.code" placeholder="请输入系列编码" @blur="checkCode"></el-input>
          <div v-if="codeCheckMessage" :class="codeCheckClass">{{ codeCheckMessage }}</div>
        </el-form-item>
        <el-form-item label="描述">
          <el-input type="textarea" :rows="3" v-model="formData.description" placeholder="请输入系列描述"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="formData.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="2">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="formData.sort" :min="0" :step="1"></el-input-number>
        </el-form-item>
        <el-form-item label="图标URL">
          <el-input v-model="formData.icon" placeholder="请输入图标URL"></el-input>
        </el-form-item>
        <el-form-item label="颜色标识">
          <el-color-picker v-model="formData.color"></el-color-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确 定</el-button>
      </div>
    </el-dialog>


  </div>
</template>

<script>
import { 
  getSeriesList, 
  createSeries, 
  updateSeries, 
  deleteSeries, 
  checkSeriesCode
} from '@/api/setMealManagment/setMealSeries'

export default {
  name: 'SetMealSeries',
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      multipleSelection: [],
      
      // 搜索表单
      searchForm: {
        name: '',
        code: '',
        status: '',
        pageNo: 1,
        pageSize: 20
      },
      
      // 对话框
      dialogVisible: false,
      dialogTitle: '',
      isEdit: false,
      formData: {
        name: '',
        code: '',
        description: '',
        status: 1,
        sort: 0,
        icon: '',
        color: ''
      },
      formRules: {
        name: [
          { required: true, message: '请输入系列名称', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入系列编码', trigger: 'blur' },
          { min: 2, max: 30, message: '长度在 2 到 30 个字符', trigger: 'blur' },
          { pattern: /^[A-Z0-9_]+$/, message: '编码只能包含大写字母、数字和下划线', trigger: 'blur' }
        ]
      },
      submitLoading: false,
      
      // 编码检查
      codeCheckMessage: '',
      codeCheckClass: ''
    }
  },
  
  mounted() {
    this.loadData()
  },
  
  methods: {
    // 加载数据
    async loadData() {
      this.loading = true
      try {
        // 构建参数，与套餐管理页面保持一致的方式
        let params = Object.assign(this.searchForm, {
          pageNo: this.searchForm.pageNo,
          pageSize: this.searchForm.pageSize,
        })
        
        const response = await getSeriesList(params)
        if (response && response.rows) {
          // 直接使用response数据，与套餐管理页面保持一致
          this.tableData = response.rows || []
          this.total = response.total || 0
          this.searchForm.pageNo = response.pageNo || this.searchForm.pageNo
          this.searchForm.pageSize = response.pageSize || this.searchForm.pageSize
        }
      } catch (error) {
        this.$message.error('加载数据失败: ' + (error.message || '未知错误'))
      } finally {
        this.loading = false
      }
    },
    

    
    // 搜索
    handleSearch() {
      this.searchForm.pageNo = 1
      this.loadData()
    },
    
    // 重置搜索
    handleReset() {
      this.searchForm = {
        name: '',
        code: '',
        status: '',
        pageNo: 1,
        pageSize: 20
      }
      this.loadData()
    },
    
    // 分页
    handleSizeChange(val) {
      this.searchForm.pageSize = val
      this.searchForm.pageNo = 1
      this.loadData()
    },
    
    handleCurrentChange(val) {
      this.searchForm.pageNo = val
      this.loadData()
    },
    
    // 选择变化
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    
    // 新增
    handleAdd() {
      this.dialogTitle = '新增系列'
      this.isEdit = false
      this.resetFormData()
      this.dialogVisible = true
    },
    
    // 编辑
    handleEdit(row) {
      this.dialogTitle = '编辑系列'
      this.isEdit = true
      this.formData = { ...row }
      this.dialogVisible = true
    },
    
    // 删除
    handleDelete(row) {
      this.$confirm(`确认删除系列"${row.name}"吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const response = await deleteSeries(row.id)
          if (response && response.system_result_key == '0') {
            this.$message({
              showClose: true,
              message: '删除成功',
              type: 'success'
            })
            this.loadData()
          } else {
            this.$message({
              showClose: true,
              message: response?.system_result_message_key || '删除失败',
              type: 'error'
            })
          }
        } catch (error) {
          this.$message({
            showClose: true,
            message: '删除失败: ' + (error.message || '未知错误'),
            type: 'error'
          })
        }
      })
    },
    

    

    
    // 表单提交
    handleSubmit() {
      this.$refs.seriesForm.validate(async (valid) => {
        if (!valid) return
        
        this.submitLoading = true
        try {
          const data = { ...this.formData }
          
          let response
          if (this.isEdit) {
            response = await updateSeries(data.id, data)
          } else {
            response = await createSeries(data)
          }
          
          // 与套餐管理页面保持一致的响应处理方式
          if (response && response.system_result_key == '0') {
            this.$message({
              showClose: true,
              message: this.isEdit ? '更新成功' : '创建成功',
              type: 'success'
            })
            this.dialogVisible = false
            this.loadData()
          } else {
            this.$message({
              showClose: true,
              message: response?.system_result_message_key || (this.isEdit ? '更新失败' : '创建失败'),
              type: 'error'
            })
          }
        } catch (error) {
          this.$message({
            showClose: true,
            message: (this.isEdit ? '更新失败' : '创建失败') + ': ' + (error.message || '未知错误'),
            type: 'error'
          })
        } finally {
          this.submitLoading = false
        }
      })
    },
    
    // 对话框关闭
    handleDialogClose() {
      this.resetFormData()
      this.codeCheckMessage = ''
      this.$refs.seriesForm?.clearValidate()
    },
    
    // 重置表单数据
    resetFormData() {
      this.formData = {
        name: '',
        code: '',
        description: '',
        status: 1,
        sort: 0,
        icon: '',
        color: ''
      }
    },
    

    
    // 检查编码
    async checkCode() {
      if (!this.formData.code) return
      
      try {
        const excludeId = this.isEdit ? this.formData.id : null
        const response = await checkSeriesCode(this.formData.code, excludeId)
        
        if (response.data && response.data.code === 0) {
          if (response.data.data) {
            this.codeCheckMessage = '编码可用'
            this.codeCheckClass = 'success-message'
          } else {
            this.codeCheckMessage = '编码已存在'
            this.codeCheckClass = 'error-message'
          }
        }
      } catch (error) {
        console.error('检查编码失败:', error)
      }
    }
  }
}
</script>

<style scoped>
.success-message {
  color: #67c23a;
  font-size: 12px;
  margin-top: 5px;
}

.error-message {
  color: #f56c6c;
  font-size: 12px;
  margin-top: 5px;
}
</style>
